import Swiper, { Pagination, FreeMode, Navigation } from 'swiper';

Swiper.use([Pagination, FreeMode, Navigation]);

const allBrandLogoSwipers = document.querySelectorAll('.wp-brand-logos');
allBrandLogoSwipers.forEach(logoSwiper => {
    const breakpoints = JSON.parse(logoSwiper.dataset.swiper)
    const swiper = new Swiper(logoSwiper, {
        slidesPerView: 2,
        spaceBetween: 33,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints
    });
})

const activeToolboxMenuItem = document.querySelector('.bim-ally-toolobx__menu .current-menu-item');
const indexOfActiveToolboxMenuItem = Array.from(document.querySelectorAll('.bim-ally-toolobx__menu .menu-item')).indexOf(activeToolboxMenuItem);
const swiperMenuToolbox = new Swiper('.swiper-toolbox', {
    slidesPerView: "auto",
    freeMode: true,
    initialSlide: indexOfActiveToolboxMenuItem
})


// Post carousel
const allPostsCarousel = document.querySelectorAll('.wp-posts-carousel');
console.log(allPostsCarousel)
allPostsCarousel.forEach(carousel => {
    const carouselSwiper = new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 33,
        breakpoints: {
            800: {
                slidesPerView: 2
            }
        },
        navigation: {
            nextEl: '.wp-posts-carousel__nav-next',
            prevEl: '.wp-posts-carousel__nav-prev',
        }
    })
})